import {Inject, Injectable, Optional} from '@angular/core';
import {IDirectPayIpgConfig, DirectPayIpgConfig} from './direct-pay-ipg.config';

@Injectable({
  providedIn: 'root'
})
export class DirectPayIpgService {
  public loadingConfig: IDirectPayIpgConfig;

  constructor(@Optional() @Inject('config') private config: IDirectPayIpgConfig) {
    console.info('[DirectPayIpgService][config]',config)
    this.loadingConfig = this.config || new DirectPayIpgConfig();
  }

}
